import type { AppState } from '@/types';

export const selectIdProp = (_: AppState, { id }: { id: string }) => id;

export const selectIdsProp = (_: AppState, { ids }: { ids: string[] }) => ids;

export const selectEntities = (state: AppState) => state.entities;

export const selectRouting = (state: AppState) => state.router;
